import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ReactTooltip from 'react-bootstrap/Tooltip';
import Text from '../Text';
import styles from './styles.scss';

export default class Tooltip extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    tooltip: PropTypes.node,
    trigger: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.oneOf(['click', 'hover', 'focus', null])),
    ]),
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    icon: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    trigger: ['focus', 'hover'],
    placement: 'top',
    icon: 'fa-question-circle',
    className: '',
  };

  constructor(props) {
    super(props);
    this.overlay = React.createRef();
    this.id = props.id || Math.random().toString(36).substring(7);
  }

  renderTooltip = (tooltipProps) => {
    return (
      <ReactTooltip id={this.id} {...tooltipProps}>
        <Text item={this.props.tooltip} />
      </ReactTooltip>
    );
  };

  render() {
    const { trigger, placement, icon, className } = this.props;

    return (
      <OverlayTrigger
        trigger={trigger}
        placement={placement}
        overlay={this.renderTooltip}
        delay={{ show: 50, hide: 50 }}
        rootClose={trigger === 'click'}
      >
        <span className={classNames(styles.tooltip, className)} role="tab" tabIndex={0}>
          <i className={`fa ${icon}`} />
        </span>
      </OverlayTrigger>
    );
  }
}
